import useTranslation from "@babackapp/translations/use-translation";
import { format } from "date-fns";
import { useAnalyticsFilters } from "../hooks/use-analytics-filters";
import { useViewerDateFnsLocale } from "@/lib/translator";

export function AnalyticsHeader() {
  const t = useTranslation();
  const { dateRange } = useAnalyticsFilters();
  const locale = useViewerDateFnsLocale();

  const fromDate = format(dateRange.from, "d MMMM yyyy", { locale });
  const toDate = format(dateRange.to, "d MMMM yyyy", { locale });

  return (
    <div className="col-span-4 mb-4 space-y-2">
      <h3 className="text-2xl leading-6 font-semibold text-gray-900">
        {t("analytics.title", { from: fromDate, to: toDate })}
      </h3>
      <p className="text-sm leading-relaxed text-muted-foreground max-w-[600px]">
        {t("analytics.subtitle")}
      </p>
    </div>
  );
}
